import React from 'react';

const SvgSetFootOnMars = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 104 104"
}, props), /*#__PURE__*/React.createElement("g", {
  className: "tourlane-CoreValues-SetFootOnMars__nc-icon-wrapper"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "tourlane-CoreValues-SetFootOnMars__path-1",
  cx: 27.332,
  cy: 27.332,
  r: 27.332
}), /*#__PURE__*/React.createElement("path", {
  id: "tourlane-CoreValues-SetFootOnMars__path-3",
  d: "M0 59.262h27.522V28.484c0-12.048-4.557-21.543-13.67-28.484C4.616 6.94 0 16.436 0 28.484v30.778z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(35.628 15)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-CoreValues-SetFootOnMars__mask-2",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-CoreValues-SetFootOnMars__path-1"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#59DD7D",
  xlinkHref: "#tourlane-CoreValues-SetFootOnMars__path-1"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#50C871",
  d: "M52.988 10.317H39.012a2.65 2.65 0 000 5.301h3.915a2.603 2.603 0 110 5.206h-8.415a2.603 2.603 0 100 5.206h24.703l-6.227-15.713zM55.31 33.716h-9.79a2.663 2.663 0 000 5.325h7.517l2.274-5.325zM3.499 13.833h9.816c1.828-.107 2.742-1.02 2.742-2.743 0-1.722-.914-2.636-2.742-2.742h-5.72C6.136 9.891 4.77 11.72 3.5 13.833z",
  mask: "url(#tourlane-CoreValues-SetFootOnMars__mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38.712 30.618)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tourlane-CoreValues-SetFootOnMars__mask-4",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#tourlane-CoreValues-SetFootOnMars__path-3"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#ECECEC",
  xlinkHref: "#tourlane-CoreValues-SetFootOnMars__path-3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M16.568 14.18a1.302 1.302 0 01.152 2.594l-.152.009H.429a1.302 1.302 0 01-.151-2.595l.151-.008h16.139zM13.761 47.263c.668 0 1.218.502 1.293 1.15l.009.152v10.034a1.302 1.302 0 01-2.595.151l-.008-.151V48.565a1.3 1.3 0 011.301-1.302z",
  mask: "url(#tourlane-CoreValues-SetFootOnMars__mask-4)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14.021,
  cy: 31.861,
  r: 6.66,
  fill: "#BDBDBD"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#BDBDBD",
  d: "M38.712 73.097a11.352 11.352 0 00-10.32 11.305v5.474h10.32v-16.78zM66.235 73.097a11.352 11.352 0 0110.32 11.305v5.474h-10.32v-16.78z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#59DD7D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.7 52.686l.93 2.326 2.324.464-1.86 1.394.93 2.323-2.324-1.392-2.323 1.392.93-2.323-1.86-1.394 2.322-.464zM28.83 43.229l.93 2.327 2.324.463-1.86 1.395.93 2.323-2.324-1.393-2.323 1.393.929-2.323-1.86-1.395 2.323-.463zM31.521 56.57l.931 2.326 2.323.464-1.86 1.394.93 2.323-2.324-1.392-2.323 1.392.93-2.323-1.86-1.394 2.323-.464z"
})))));

export default SvgSetFootOnMars;